<template>
  <div id="div2" style="text-align: left; height: 100%; width: 100%">
    <div style="margin-bottom: 0px; margin-left: 10px; font-weight: bold">
      <Button @click="setPage">轨迹数据</Button>
      <Button @click="fillter">停车数据</Button>
      <span>总里程:{{ allLength }}公里，</span>
      <span>总时长:{{ allTime }}</span>
    </div>
    <div style="clear: both"></div>
    <lyTable
      :height="height - 110"
      :columns="columns2"
      :data="historyData"
      highlight-row
      @on-row-click="rowData"
    >
    </lyTable>

    <div id="mypage">
      <Button @click="addExportTask(select)" type="text">导出数据</Button>
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[1000, 2000, 3000, 5000]"
          show-total
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <exportLocus ref="exportLocus"></exportLocus>
  </div>
</template>
<script>
import axios from "axios";
import Direction from "../common/Direction.vue";
import exportLocus from "./export.vue";
import lyTable from "./lytable.vue";
var jindu;
export default {
  props: ["mapData", "height"],
  components: { Direction, exportLocus, lyTable },
  data() {
    return {
      tableHeight: 0,
      fresh: false,
      modal: false,
      modal1: false,
      isFenxi: false, //是否分析模式
      columns2: [
        {
          type: "index",
          width: 70,
          align: "center",
          fixed: "left",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "GPS时间",
          key: "gpsTime2",
          align: "left",
          minWidth: 130,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "上报时间",
          key: "reportTime2",
          align: "left",
          minWidth: 130,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "位置地址",
          key: "address",
          align: "left",
          width: 300,
          tooltip: true,
        },
        {
          title: "停车时长",
          key: "parkDuration1",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "开始停车",
          key: "startParkTime",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "结束停车",
          key: "endParkTime",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "绝对里程/km",
          key: "mileage",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "相对里程/km",
          key: "mileage1",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "速度/km/h",
          key: "speed",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "发动机",
          key: "accStatus1",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
        },
        {
          title: "信号",
          key: "flag1",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },

        {
          title: "油量电阻值",
          key: "oil",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "方向度数",
          key: "directionDegree",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "司机从业资格证",
          key: "dqcNo",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "事件报告",
          key: "eventDesc",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "高德经度(GCJ-02)",
          key: "returnX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "高德纬度(GCJ-02)",
          key: "returnY",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始经度(WGS-84)",
          key: "orgX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始纬度(WGS-84)",
          key: "orgY",
          minWidth: 160,
          maxWidth: 200,
        },
      ],
      title: "",
      tableDate: [], //分页前
      historyData: [], //分页后
      total: 0,
      tableDatedaochu: [],
      pageNumber: 1,
      pageSize: 1000, //每页数量
      select: {},
      exportTaskPro: 0, //任务进度
      taskId: "",
      finish: false,
      allLength: 0,
      allTime: 0,
    };
  },
  methods: {
    //当前行的数据
    rowData(data) {
      this.$emit("drawPoint", data);
    },
    getHistory(x) {
      this.select = x;
      let params = {
        deviceNo: this.select.deviceNo,
        endTime: this.select.end.getTime(),
        startTime: this.select.start.getTime(),
        space: 3000,
        directionDegree: 0,
        //pageSize: this.pageSize,
        //pageNumber: this.pageNumber,
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
      };
      this.utils.loading(this, "加载中");
      var url;
      if (x.val == 1) {
        this.title = "轨迹数据列表";
        url = axios.lbs + "/locus/getPlyLocus";
      } else if (x.val == 3) {
        this.title = "全部原始轨迹数据表";
        url = axios.lbs + "/locus/getOrgLocus";
        ///cloud-common-server-lbs/locus/getOrgLocus
      }
      axios({
        method: "post",
        url: url,
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data.dataList;
        //console.log(data);
        for (const i in data) {
          //data[i].address = "";
          data[i].accStatus1 = this.$t("accStatus." + data[i].accStatus);
          data[i].flag1 = this.$t("flag." + data[i].flag);
          data[i].parkDuration1 = this.utils.duration(data[i].parkDuration);
          data[i].gpsTime2 = this.utils.time(data[i].gpsTime);
          data[i].reportTime2 = this.utils.time(data[i].recordTime);
          data[i].startParkTime = this.utils.time(data[i].startParkTime);
          data[i].endParkTime = this.utils.time(data[i].endParkTime);
          data[i].mileage1 = (data[i].mileage - data[0].mileage).toFixed(1);
        }
        this.tableDate = data;
        this.total = res.data.data.total;
        if (this.total == 0) {
          return;
        }

        this.allLength = (
          data[data.length - 1].mileage - data[0].mileage
        ).toFixed(2);
        var tt = (data[data.length - 1].gpsTime - data[0].gpsTime) / 1000;
        this.allTime = this.utils.duration(tt);
        /* var pointList = [];
        for (const i in data) {
          var obj = {
            x: data[i].orgX,
            y: data[i].orgY,
          };
          pointList.push(obj);
        }
        this.utils.jiexi(pointList).then((x) => {
          for (const i in data) {
            data[i].address = x[i].address;
          }
        }); */
        this.setPage();
      });
    },
    setPage() {
      this.historyData = this.utils.page(
        this.pageNumber,
        this.pageSize,
        this.tableDate
      );
    },
    fillter() {
      var data = this.tableDate;
      //console.log(data);

      var m = data.filter(function (item) {
        return item.parkDuration > 1;
      });
      this.historyData = m;
      console.log(m);
    },
    //页码切换时触发
    changePage(x) {
      this.pageNumber = x;
      this.setPage();
      //this.getHistory(this.select);
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.setPage();
      //his.getHistory(this.select);
    },
    addExportTask(v) {
      v.tt = "车辆";
      this.$refs.exportLocus.reachData(v);
    },
  },
  watch: {
    height(v) {
      this.tableHeight = v;
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/locus/listAll.vue